import { render, staticRenderFns } from "./v-hero-slider.vue?vue&type=template&id=130787a8&scoped=true&"
import script from "./v-hero-slider.vue?vue&type=script&lang=js&"
export * from "./v-hero-slider.vue?vue&type=script&lang=js&"
import style0 from "./v-hero-slider.vue?vue&type=style&index=0&id=130787a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130787a8",
  null
  
)

export default component.exports